import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedParentPostView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/parent_post/applied_parent_post"]

  unmodifiableByModerators: true

  removeFilter: ->
    @searchQuery.removeParentPostId()